import React from 'react';
import './ReceiptOverviewLayout.css';

// Shared by full-page, sidebar and dialog previews. The host width, not the
// viewport width, decides whether the document and events fit side by side.
export default function ReceiptOverviewLayout({children}) {
  return <div className="receipt-overview-container">
    <div className="receipt-overview-layout">{children}</div>
  </div>;
}
